import { useMemo } from 'react';
import {
  ProductionCostClosingSnapshot,
  type ProductionCostClosingDetailSource,
} from '@/components/Approval/@components/ProductionCostClosing';
import { parseProductionCostClosingContent } from '@/utils/approval/productionCostClosing';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 124 GERP 생산비 마감 — 저장 본문 그대로(레거시 문서 포함), 행 「상세보기」만 문서번호로 GERP 현재 값 조회 */
const ProductionCostClosingSlot = ({ data }: ContentExtraProps) => {
  const content = parseProductionCostClosingContent(data.attributes);
  const detailSource = useMemo<ProductionCostClosingDetailSource>(
    () => ({ kind: 'document', documentId: data.documentId }),
    [data.documentId],
  );
  if (!content) return null;
  const approvalId = data.attributes?.approvalId;
  return (
    <ContentSlotRoot>
      <ProductionCostClosingSnapshot
        content={content}
        detailSource={detailSource}
        approvalId={typeof approvalId === 'string' ? approvalId : ''}
      />
    </ContentSlotRoot>
  );
};

export default ProductionCostClosingSlot;
